
import React , { useState, useRef, useEffect } from "react"
import { BNPrintLabel } from '../../../../src/networking/NetworkingOrders'
import { getConfirmation } from "../../bnotes_order/OrderService";

export function PrintLabel({bnOrderNo}) {
    const [body, setBody] = useState('');
    const [features, setFeatures] = useState('');

  useEffect(() => {
    const loadDefault = async () => {
      const json_request = {
        BNOrderNo: bnOrderNo
      }
      const response = await BNPrintLabel(json_request);
      if (response !== undefined) {
        setBody(response.body);
        setFeatures(response.features);
      }
    }
    loadDefault();
  }, []);
  
  const handlePrint = () => {
    const printWindow = window.open("", "", features)
    if (printWindow) {
      printWindow.document.write(body)
      printWindow.document.close()
      printWindow.print()
    }
  }

  return (
    <button className="uk-button uk-button-green" onClick={handlePrint} >
        Print Label
    </button>
  )
}

export async function Print(bnOrderNo, listSelectedOrders) {
  let cadena="";
  if(listSelectedOrders !== undefined && listSelectedOrders !== null && listSelectedOrders.length > 0){
    const list = []
    for(let i=0;i<listSelectedOrders.length;i++ )
    {
      list.push(listSelectedOrders[i].BNOrderNo);
    }
    cadena = list.join(","); 
  }  
  const json_request = {
    BNOrderNo: bnOrderNo,
    ListSelectedOrders: cadena
  }
  const response = await BNPrintLabel(json_request);
  const printWindow = window.open("", "_blank", response.features)
  if (printWindow) {
    printWindow.document.write(response.body)
    printWindow.document.close()
    printWindow.print()
  }
}

export async function PrintConfirmation(listSelectedOrders){
  //1. Open all the windows first
  const openedWindows = listSelectedOrders.map(() => window.open('', '_blank') );

  const confirmation = await getConfirmation(
    listSelectedOrders[0].BNOrderNo
  );
  
  const docWindow = openedWindows[0];
  
  if (confirmation?.Success && docWindow && !docWindow.closed) {
      const fileURL = URL.createObjectURL(confirmation.File);
  
      docWindow.location.replace(fileURL);
      docWindow.focus();
  
      // Esperar a que Chrome inicialice el visor PDF.
      setTimeout(() => {
          if (!docWindow.closed) {
              docWindow.focus();
              docWindow.print();
          }
      }, 6000);
  
  } else if (docWindow && !docWindow.closed) {
      docWindow.close();
  } 
}